<script>
  import { onDestroy } from "svelte";

  import RowsContainer from "../container/RowsContainer.svelte";
  import StepperHeadline from "../stepper/StepperHeadline.svelte";
  import { showLoading } from "../../stores/mainStore";
  import Image from "../display/Image.svelte";
  import { rgbToHex } from "../../helper/UIHelper";
  import Button from "../ui/Button.svelte";

  import FileSelect from "../ui/FileSelect.svelte";
  import ColorPicker from "../ui/ColorPicker.svelte";
  import Loading from "../display/Loading.svelte";
  import SelectBox from "../display/SelectBox.svelte";
  import { createEventDispatcher } from "svelte";

  export let model;
  let logoUid;
  // import * as Vibrant from 'node-vibrant/lib/vibrant.js'
  import ColorThief from "colorthief/dist/color-thief.min.js";

  function extractColors() {
    //TODO
    setTimeout(async () => {
      let img = document.getElementById(`preview_logo_1`);
      if (img == null) img = document.getElementById(`preview_hero_1`);
      if (img == null) img = document.getElementById(`preview_hero_2`);
      if (img == null) {
        model.design.mainColor.hex = "#C90920";
        return;
      }
      const colorThief = new ColorThief();
      if (img.complete) {
        const colors = await colorThief.getPalette(img, 3);
        setColorPalette(colors);
      } else {
        img.addEventListener("load", async function() {
          const colors = await colorThief.getPalette(img, 3);
          setColorPalette(colors);
        });
      }
    }, 200);
  }

  function setColorPalette(palette) {
    model.design.logoPalette = [];
    for (let i = 0; palette.length > i; i++) {
      model.design.logoPalette.push({
        hex: rgbToHex(palette[i][0], palette[i][1], palette[i][2]),
        rgbaObject: palette[i]
      });
    }
    model.design.mainColor = model.design.logoPalette[0];
  }
  const unsubscribe = showLoading.subscribe(value => {
    if (value == false) {
      extractColors();
      if (model.design.images.logo_1 != null)
        model.design.logo = model.design.images.logo_1;
      if (model.design.images.hero_1 != null)
        model.design.hero = model.design.images.hero_1;
      else if (model.design.hero == null && model.design.images.hero_2 != null)
        model.design.hero = model.design.images.hero_2;
    }
  });

  //TODO change colors when logo is set manually

  onDestroy(() => {
    unsubscribe();
  });

  const dispatch = createEventDispatcher();
  const back = () => dispatch("back");
</script>

<StepperHeadline>
  <h1>
    Check your
    <span class="text-yellow">design</span>
  </h1>
  <p>
    Here’s what we got from
    <b>{model.product.website}.</b>
    <br />
    Choose what’s right or tweak if necessary.
  </p>
</StepperHeadline>

<div class="mt-6" class:hidden={$showLoading}>
  <div class="flex flex-row ">
    <span class="flex-grow" />
    <Button class="mr-4" on:submit={back} raised={true}>Back</Button>
    <Button type="submit" raised={true} primary={true}>
      Continue to Business
    </Button>
    <span class="flex-grow" />
  </div>
</div>
<div class="relative">

  <RowsContainer>
    <div class="text-center lg:px-12 xl:px-24" class:invisible={$showLoading}>
      <h2 class="text-xl leading-4 mb-4">Pick Your Logo</h2>
      {#if model.design.images.logo_1 != null}
        <SelectBox
          class="mb-4 h-18 w-auto mx-auto"
          bind:model={model.design.logo}
          entry={model.design.images.logo_1}>
          <Image
            src={model.design.images.logo_1.public}
            isExternal={true}
            id="preview_logo_1"
            class="h-16 min-w-16 mx-auto p-1" />

        </SelectBox>
      {:else}
        <SelectBox
          class="mb-4 h-18 w-auto mx-auto"
          bind:model={model.design.logo}
          entry={null}>
          <Image
            src="./assets/Logo.png"
            isExternal={true}
            class="h-16 min-w-16 mx-auto p-1" />

        </SelectBox>
      {/if}

      {#if model.design.customLogo != null}
        <SelectBox
          bind:model={model.design.logo}
          entry={model.design.customLogo}
          class="h-18 min-w-18 w-auto mx-auto">
          <FileSelect
            bind:model={model.design.customLogo}
            minMode={true}
            disabled={model.design.logo != model.design.customLogo}
            on:onInit={setTimeout(() => {
              model.design.logo = model.design.customLogo;
            }, 200)}
            on:change={(model.design.logo = model.design.customLogo)}
            class="h-18 min-w-18 mx-auto p-1 max-h-18" />
        </SelectBox>
      {:else}
        <FileSelect
          bind:model={model.design.customLogo}
          minMode={true}
          class="w-full"
          linkText="or upload a logo" />
      {/if}
    </div>
    <div class="text-center" class:invisible={$showLoading}>
      <h2 class="text-xl leading-4 mb-4">Choose Your Color</h2>
      {#if model.design.logoPalette != null}
        <div class="sm:flex sm:flex-row">
          {#each model.design.logoPalette as color}
            <div>
              <SelectBox
                class="mx-2"
                bind:model={model.design.mainColor}
                entry={color}>
                <div class="sm:w-16 h-16" style="background:{color.hex}" />
              </SelectBox>
              <span class="text-xs">{color.hex}</span>
            </div>
          {/each}
          {#if model.design.logoPalette.length > 0}
            <div>
              <SelectBox
                class="mx-2"
                bind:model={model.design.mainColor}
                entry={model.design.customColor}>
                <ColorPicker
                  class="sm:w-16 h-16"
                  bind:model={model.design.customColor}
                  emptyStart={true} />
              </SelectBox>
              <span class="text-xs">
                {model.design.customColor.hex != null ? model.design.customColor.hex : ''}
              </span>
            </div>
          {/if}

        </div>
      {/if}
    </div>
    <div class="text-center lg:px-12 xl:px-24" class:invisible={$showLoading}>
      <h2 class="text-xl leading-4 mb-4">Pick Your Hero Image</h2>
      {#if model.design.images.hero_1 != null}
        <SelectBox
          class="mb-4"
          bind:model={model.design.hero}
          entry={model.design.images.hero_1}>
          <Image
            src={model.design.images.hero_1.public}
            isExternal={true}
            id="preview_hero_1"
            class="" />
        </SelectBox>
      {/if}
      {#if model.design.images.hero_2 != null}
        <SelectBox
          class="mb-4"
          bind:model={model.design.hero}
          entry={model.design.images.hero_2}>
          <Image
            src={model.design.images.hero_2.public}
            isExternal={true}
            id="preview_hero_2"
            class="" />
        </SelectBox>
      {/if}
      {#if model.design.images.hero_1 == null && model.design.images.hero_2 == null}
        <SelectBox class="mb-4" bind:model={model.design.hero} entry={null}>
          <Image src="./assets/Hero_Image.png" isExternal={true} class="" />
        </SelectBox>
      {/if}
      {#if model.design.customHero != null}
        <SelectBox
          bind:model={model.design.hero}
          entry={model.design.customHero}>
          <FileSelect
            bind:model={model.design.customHero}
            minMode={true}
             disabled={model.design.logo != model.design.customLogo}
            on:onInit={(model.design.hero = model.design.customHero)}
            on:change={(model.design.hero = model.design.customHero)}
            class="w-full" />
        </SelectBox>
      {:else}
        <FileSelect
          bind:model={model.design.customHero}
          minMode={true}
          class="w-full"
          linkText="or upload a screenshot or image" />
      {/if}
    </div>
  </RowsContainer>
  {#if $showLoading}
    <div
      class="absolute top-0 left-0 w-full h-full bg-white"
      style="min-height:500px;">
      <Loading mode={0} />
    </div>
  {/if}
</div>
